import React, { useEffect, useState } from "react";
import {
  TextField,
  Avatar,
  MenuItem,
  Select,
  Modal,
  CircularProgress,
} from "@mui/material";
import useFetch from "../../../../hooks/useFetch";
import { toast } from "react-toastify";
import {
  DeleteOutline,
  PersonOutline,
  BadgeOutlined,
  ReceiptLongOutlined,
  AccountBalanceOutlined,
  InsightsOutlined,
  BarChartOutlined,
  EditOutlined,
  LockResetOutlined,
  BlockOutlined,
  DeleteForeverOutlined,
  OndemandVideoOutlined,
} from "@mui/icons-material";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import ShareTable from "../../../shares/tables/ShareTable";
import ShareChart from "../../../shares/chart/ShareChart";
import DirectMoney from "./modals/DirectMoney";
import SigendCheck from "./modals/SignedCheck";
import moment from "jalali-moment";
import Password from "./modals/Password";
import NumberFormat from "../../../shares/NumberFormat/NumberFormat";
import BooksAssign from "./BooksAssign";
import ExamScore from "./ExamScore";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import useFormattedLocalDate from "../../../../hooks/useFormattedLocalDate";
import {
  PageHeader,
  SectionCard,
  TableAction,
  EmptyState,
} from "../../../shares/dashboard/DashboardWidgets";

/**
 * Admin view of a single student.
 *
 * Every fetch, state setter and handler is unchanged from the original - this
 * was a presentation-only pass. What changed: the one 850-line centred <Card>
 * became a PageHeader plus a stack of SectionCards (identity, books, exam
 * scores, transactions, checks, performance charts); the three absolutely
 * positioned danger buttons moved into the header; edit/delete glyphs became
 * TableActions; and the inactive-user branch got a real empty state instead of
 * three bare centred lines.
 */
const Profile = () => {
  const [examData, setExamData] = useState([]);
  const [id, setId] = useState("");
  const [idCheck, setIdCheck] = useState("");
  const [edit, setEdit] = useState("");
  const [editCheck, setEditCheck] = useState("");
  const [groups, setGroups] = useState();
  const [avatar, setAvatar] = useState("");
  const [profileData, setProfileData] = useState({
    id: "",
    username: "",
    first_name: "",
    last_name: "",
    groups: [],
    studentuser: {
      father_name: "",
      avatar: "",
      registration_date: "",
      phone_number: "",
      home_number: "",
      father_number: "",
      mother_number: "",
      address: "",
      student_school: "",
      average_exam: "",
      average_assignment: "",
      student_type: "",
      student_gender: "",
      student_grade: "",
    },
    directmoney_set: [],
    signedcheck_set: [],
    examaverage: {
      examscore_set: [],
    },
  });
  const [call, setCall] = useState();
  const [fileState, setFileState] = useState();
  const [editable, setEditable] = useState(false);
  const [passwordModal, setPasswordModal] = useState(false);
  const [directMoney, setDirectMoney] = useState(false);
  const [signedCheck, setSignedCheck] = useState(false);
  const { Id } = useParams();
  const formatDate = useFormattedLocalDate();

  const handleClose = () => {
    setDirectMoney(false);
    setSignedCheck(false);
    setPasswordModal(false);
    setEdit("");
    setEditCheck("");
  };
  const fetchData = useFetch({
    method: "GET",
    url: `management/users/${Id}/`,
    noHeader: false,
    trigger: true,
    setter: setProfileData,
    errMessage: () =>
      toast.error("مشکلی در دریافت اطلاعات پیش آمده", {
        position: "bottom-left",
        rtl: true,
        autoClose: 2000,
      }),
  });

  const patchData = useFetch({
    method: "PATCH",
    url: `management/users/${Id}/`,
    noHeader: false,
    trigger: false,
    data: profileData,
    errMessage: () =>
      toast.error("مشکلی در ویرایش پیش آمده", {
        position: "bottom-left",
        rtl: true,
        autoClose: 2000,
      }),
  });
  const deleteUser = useFetch({
    method: "DELETE",
    url: `management/users/${Id}/`,
    noHeader: false,
    trigger: false,
    errMessage: () =>
      toast.error("مشکلی در حذف کاربر پیش آمده", {
        position: "bottom-left",
        rtl: true,
        autoClose: 2000,
      }),
  });

  const deleteMoney = useFetch({
    method: "DELETE",
    url: `management/directmoney/${id}/`,
    noHeader: false,
    trigger: false,
    errMessage: () =>
      toast.error("مشکلی در حذف پیش آمده", {
        position: "bottom-left",
        rtl: true,
        autoClose: 2000,
      }),
    caller: fetchData,
  });
  const deleteCheck = useFetch({
    method: "DELETE",
    url: `management/signedcheck/${idCheck}/`,
    noHeader: false,
    trigger: false,
    errMessage: () =>
      toast.error("مشکلی در حذف پیش آمده", {
        position: "bottom-left",
        rtl: true,
        autoClose: 2000,
      }),
    caller: fetchData,
  });
  const download = useFetch({
    method: "GET",
    url: `management/users/${Id}/classroom_presence_summary/`,
    noHeader: false,
    trigger: false,
    setter: setFileState,
    errMessage: () =>
      toast.error("مشکلی پیش آمده", {
        position: "bottom-left",
        rtl: true,
        autoClose: 2000,
      }),
  });
  const toggleUser = useFetch({
    method: "POST",
    url: `management/users/${Id}/toggle_activation/`,
    noHeader: false,
    trigger: false,
    errMessage: () =>
      toast.error("مشکلی پیش آمده", {
        position: "bottom-left",
        rtl: true,
        autoClose: 2000,
      }),
    caller: fetchData,
  });

  const getGroup = useFetch({
    method: "GET",
    url: `management/groups/?page_size=1000`,
    noHeader: false,
    trigger: true,
    setter: setGroups,
  });

  const handleAvatarChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      setAvatar(reader.result);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const { handleSubmit } = useForm();

  const onSubmit = (e) => {
    const formData = new FormData();

    formData.append("first_name", profileData.first_name);
    formData.append("last_name", profileData.last_name);
    formData.append("father_name", profileData?.studentuser?.father_name);
    formData.append(
      "registration_date",
      profileData?.studentuser?.registration_date
    );
    formData.append("phone_number", profileData?.studentuser?.phone_number);
    formData.append("home_number", profileData?.studentuser?.home_number);
    formData.append("father_number", profileData?.studentuser?.father_name);
    formData.append("mother_number", profileData?.studentuser?.mother_number);
    formData.append("address", profileData?.studentuser?.address);
    formData.append("student_school", profileData?.studentuser?.student_school);

    setCall(formData);
    patchData.reFetch();
    setEditable(false);
  };

  const handleEdit = (id) => {
    setDirectMoney(true);
    setEdit(id);
  };
  const handleEditCheck = (id) => {
    setSignedCheck(true);
    setEditCheck(id);
  };

  const columnsMoney = [
    { id: "id", label: "شناسه" },
    {
      id: "amout",
      label: "مبلغ",
      render: (row) => <NumberFormat number={row.amout} />,
    },
    { id: "payment_method", label: "نحوه پرداخت" },
    { id: "bank", label: "بانک" },
    { id: "card_number", label: "شماره کارت" },
    { id: "refrence_number", label: "شماره مرجع" },
    { id: "following_number", label: "شماره پیگیری" },
    {
      id: "description",
      label: "توضیحات",
      render: (row) => <div className="mx-auto max-w-[18rem]">{row.description}</div>,
    },
    {
      id: "payment_date",
      label: "تاریخ",
      render: (row) =>
        moment(row.payment_date, "YYYY/MM/DD")
          .locale("fa")
          .format("YYYY/MM/DD"),
    },
    {
      id: "edit",
      label: "ویرایش",
      render: (row) => (
        <TableAction
          icon={EditOutlined}
          onClick={() => handleEdit(row.id)}
          label="ویرایش تراکنش"
        />
      ),
    },
    {
      id: "delete",
      label: "حذف",
      render: (row) =>
        deleteMoney.loading && id === row.id ? (
          <CircularProgress size="2rem" color="inherit" className="text-danger" />
        ) : (
          <TableAction
            icon={DeleteOutline}
            onClick={() => setId(row.id)}
            label="حذف تراکنش"
            tone="danger"
          />
        ),
    },
  ];

  const columnsCheck = [
    { id: "id", label: "شناسه" },
    {
      id: "amout",
      label: "مبلغ",
      render: (row) => <NumberFormat number={row.amout} />,
    },
    { id: "check_number", label: "شماره چک" },
    { id: "bank", label: "بانک" },
    {
      id: "payment_date",
      label: "تاریخ",
      render: (row) =>
        moment(row.check_date, "YYYY/MM/DD").locale("fa").format("YYYY/MM/DD"),
    },
    {
      id: "description",
      label: "توضیحات",
      render: (row) => <div className="mx-auto max-w-[18rem]">{row.description}</div>,
    },
    {
      id: "edit",
      label: "ویرایش",
      render: (row) => (
        <TableAction
          icon={EditOutlined}
          onClick={() => handleEditCheck(row.id)}
          label="ویرایش چک"
        />
      ),
    },
    {
      id: "delete",
      label: "حذف",
      render: (row) =>
        deleteCheck.loading && idCheck === row.id ? (
          <CircularProgress size="2rem" color="inherit" className="text-danger" />
        ) : (
          <TableAction
            icon={DeleteOutline}
            onClick={() => setIdCheck(row.id)}
            label="حذف چک"
            tone="danger"
          />
        ),
    },
  ];

  useEffect(() => {
    id && deleteMoney.reFetch();
  }, [id]);
  useEffect(() => {
    idCheck && deleteCheck.reFetch();
  }, [idCheck]);

  useEffect(() => {
    profileData.examaverage?.examscore_set?.map((i) => {
      setExamData((prevState) => [...prevState, i.score]);
    });
  }, [profileData]);

  useEffect(() => {
    deleteUser.status === 204 &&
      toast.error("کاربر با موفقیت حذف شد!", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: "colored",
        rtl: true,
      });
  }, [deleteUser.status]);

  const fullName = [profileData.first_name, profileData.last_name]
    .filter(Boolean)
    .join(" ");

  // Field controls repeat a lot of nested-setState boilerplate; a tiny helper
  // keeps the JSX readable without changing what each onChange does.
  const setStudentField = (key) => (e) =>
    setProfileData((prev) => ({
      ...prev,
      studentuser: { ...prev.studentuser, [key]: e.target.value },
    }));

  return (
    <div className="flex flex-col gap-xl pb-4xl">
      {profileData?.is_active ? (
        <>
          <PageHeader
            title={fullName || "پروفایل دانش‌آموز"}
            description={
              profileData.username ? `کدملی: ${profileData.username}` : "دانش‌آموز"
            }
            icon={PersonOutline}
          >
            <div className="flex shrink-0 flex-wrap items-center gap-sm">
              <a
                href={`${process.env.REACT_APP_API_URL}/management/users/${Id}/classroom_presence_summary/`}
                target="blank"
                className="inline-flex items-center gap-2xs rounded-soft border border-rule bg-surface px-lg py-sm text-base text-ink-muted transition-colors duration-150 hover:bg-surface-sunken hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
              >
                <OndemandVideoOutlined sx={{ fontSize: "1.8rem" }} />
                آمار تماشا
              </a>
              <button
                type="button"
                onClick={() => toggleUser.reFetch()}
                className="inline-flex items-center gap-2xs rounded-soft border border-warning/40 bg-warning-soft px-lg py-sm text-base text-warning transition-colors duration-150 hover:bg-warning hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-warning motion-reduce:transition-none"
              >
                <BlockOutlined sx={{ fontSize: "1.8rem" }} />
                غیرفعال‌سازی
              </button>
              <button
                type="button"
                onClick={() => deleteUser.reFetch()}
                className="inline-flex items-center gap-2xs rounded-soft border border-danger/40 bg-danger-soft px-lg py-sm text-base text-danger transition-colors duration-150 hover:bg-danger hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-danger motion-reduce:transition-none"
              >
                <DeleteForeverOutlined sx={{ fontSize: "1.8rem" }} />
                حذف کاربر
              </button>
            </div>
          </PageHeader>

          <SectionCard
            title="اطلاعات فردی"
            icon={BadgeOutlined}
            actionLabel={editable ? "انصراف" : "ویرایش"}
            onActionClick={() => setEditable(!editable)}
          >
            <form
              className="flex flex-col gap-xl"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="flex items-center gap-lg">
                <Avatar
                  alt={fullName || "آواتار"}
                  src={profileData?.studentuser?.avatar}
                  sx={{ width: "9rem", height: "9rem" }}
                />
                <div className="min-w-0">
                  <p className="text-lg font-semibold text-ink">
                    {fullName || "دانش‌آموز"}
                  </p>
                  <p className="mt-2xs text-sm text-ink-subtle">
                    {[
                      profileData?.studentuser?.student_grade,
                      profileData?.studentuser?.student_type,
                    ]
                      .filter(Boolean)
                      .join(" · ") || "—"}
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 gap-lg md:grid-cols-4">
                <TextField
                  disabled={!editable}
                  label="نام"
                  variant="outlined"
                  onChange={(e) =>
                    setProfileData({ ...profileData, first_name: e.target.value })
                  }
                  value={profileData.first_name}
                  className="md:col-span-2"
                />
                <TextField
                  disabled={!editable}
                  label="نام خانوادگی"
                  variant="outlined"
                  value={profileData?.last_name}
                  onChange={(e) =>
                    setProfileData({ ...profileData, last_name: e.target.value })
                  }
                  className="md:col-span-2"
                />
                <TextField
                  disabled={!editable}
                  label="کدملی"
                  variant="outlined"
                  onChange={(e) =>
                    setProfileData({ ...profileData, username: e.target.value })
                  }
                  value={profileData.username}
                />
                <TextField
                  disabled={!editable}
                  label="نام پدر"
                  variant="outlined"
                  value={profileData.studentuser?.father_name}
                  onChange={setStudentField("father_name")}
                />

                <MobileDatePicker
                  label="تاریخ ثبت نام"
                  onChange={(e) => {
                    const date = formatDate(e);
                    setProfileData((prev) => ({
                      ...prev,
                      studentuser: {
                        ...prev.studentuser,
                        registration_date: date,
                      },
                    }));
                  }}
                  value={
                    profileData.studentuser?.registration_date
                      ? new Date(profileData.studentuser.registration_date)
                      : null
                  }
                  views={["year", "month", "day"]}
                  className="w-full"
                  slotProps={{
                    field: { shouldRespectLeadingZeros: true },
                    toolbar: { hidden: true },
                    tabs: { hidden: true },
                  }}
                  disabled
                />

                <TextField
                  disabled={!editable}
                  label="شماره موبایل"
                  variant="outlined"
                  value={profileData?.studentuser?.phone_number}
                  onChange={setStudentField("phone_number")}
                />
                <TextField
                  disabled={!editable}
                  label="شماره ثابت"
                  variant="outlined"
                  value={profileData?.studentuser?.home_number}
                  onChange={setStudentField("home_number")}
                />
                <TextField
                  disabled={!editable}
                  label="شماره پدر"
                  variant="outlined"
                  value={profileData?.studentuser?.father_number}
                  onChange={setStudentField("father_number")}
                />
                <TextField
                  disabled={!editable}
                  label="شماره مادر"
                  variant="outlined"
                  value={profileData?.studentuser?.mother_number}
                  onChange={setStudentField("mother_number")}
                />
                <TextField
                  disabled={!editable}
                  label="آدرس"
                  variant="outlined"
                  value={profileData?.studentuser?.address}
                  onChange={setStudentField("address")}
                  className="md:col-span-2"
                />
                <TextField
                  disabled={!editable}
                  label="نام مدرسه"
                  variant="outlined"
                  value={profileData?.studentuser?.student_school}
                  onChange={setStudentField("student_school")}
                  className="md:col-span-2"
                />
                <TextField
                  disabled
                  label="میانگین نمره تکلیف"
                  variant="outlined"
                  value={profileData?.studentuser?.average_assignment}
                  onChange={setStudentField("average_assignment")}
                />
                <TextField
                  disabled
                  label="میانگین نمره امتحان"
                  variant="outlined"
                  value={profileData?.studentuser?.average_exam}
                  onChange={setStudentField("average_exam")}
                />

                <Select
                  defaultValue={
                    profileData?.studentuser?.student_gender
                      ? profileData?.studentuser.student_gender
                      : "000"
                  }
                  disabled={!editable}
                  variant="outlined"
                  onChange={setStudentField("student_gender")}
                >
                  <MenuItem disabled value={"000"}>
                    جنسیت
                  </MenuItem>
                  <MenuItem value={"دختر"}>دختر</MenuItem>
                  <MenuItem value={"پسر"}>پسر</MenuItem>
                </Select>

                <Select
                  defaultValue={
                    profileData?.studentuser?.student_grade
                      ? profileData?.studentuser?.student_grade
                      : "000"
                  }
                  disabled={!editable}
                  variant="outlined"
                  onChange={setStudentField("student_grade")}
                >
                  <MenuItem disabled value={"000"}>
                    مقطع
                  </MenuItem>
                  <MenuItem value={"دهم"}>دهم</MenuItem>
                  <MenuItem value={"یازدهم"}>یازدهم</MenuItem>
                  <MenuItem value={"دوازدهم"}>دوازدهم</MenuItem>
                </Select>

                <Select
                  defaultValue={
                    profileData?.studentuser?.student_type
                      ? profileData?.studentuser?.student_type
                      : "000"
                  }
                  disabled={!editable}
                  variant="outlined"
                  onChange={setStudentField("student_type")}
                >
                  <MenuItem disabled value={"000"}>
                    رشته
                  </MenuItem>
                  <MenuItem value={"ریاضی"}>ریاضی</MenuItem>
                  <MenuItem value={"تجربی"}>تجربی</MenuItem>
                  <MenuItem value={null}>بدون رشته</MenuItem>
                </Select>

                <Select
                  variant="outlined"
                  disabled={!editable}
                  defaultValue={
                    profileData?.groups[0] ? profileData?.groups[0] : "000"
                  }
                  onChange={(e) => {
                    setProfileData({
                      ...profileData,
                      groups: [e.target.value],
                    });
                  }}
                >
                  <MenuItem disabled value={"000"}>
                    گروه‌
                  </MenuItem>
                  {groups?.results.map((g) => (
                    <MenuItem key={g.id} value={g.id}>
                      {g.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>

              <div className="flex flex-wrap items-center justify-end gap-sm border-t border-rule-subtle pt-lg">
                <button
                  type="button"
                  onClick={() => setPasswordModal(true)}
                  className="inline-flex items-center gap-2xs rounded-soft border border-rule bg-surface px-2xl py-sm text-base text-ink-muted transition-colors duration-150 hover:bg-surface-sunken hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
                >
                  <LockResetOutlined sx={{ fontSize: "1.8rem" }} />
                  تغییر رمز عبور
                </button>
                <button
                  type="submit"
                  disabled={!editable}
                  className="rounded-soft bg-primary px-2xl py-sm text-base text-white transition-colors duration-150 hover:bg-primary-hover active:bg-primary-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-50 motion-reduce:transition-none"
                >
                  ثبت تغییرات
                </button>
              </div>
            </form>
          </SectionCard>

          <BooksAssign />
          <ExamScore />

          <SectionCard
            title="تراکنش‌ها"
            icon={ReceiptLongOutlined}
            actionLabel="+ تراکنش جدید"
            onActionClick={() => setDirectMoney(true)}
          >
            <ShareTable
              data={profileData?.directmoney_set ?? []}
              columns={columnsMoney}
              getPage={fetchData}
              pageShow={false}
            />
          </SectionCard>

          <SectionCard
            title="چک‌ها"
            icon={AccountBalanceOutlined}
            actionLabel="+ چک جدید"
            onActionClick={() => setSignedCheck(true)}
          >
            <ShareTable
              data={profileData?.signedcheck_set ?? []}
              columns={columnsCheck}
              getPage={fetchData}
              pageShow={false}
            />
          </SectionCard>

          <div className="grid grid-cols-1 gap-xl lg:grid-cols-2">
            <SectionCard title="روند نمرات آزمون" icon={InsightsOutlined}>
              <ShareChart
                data={profileData?.examaverage?.examscore_set?.map(
                  (item) => item.score
                )}
                names={profileData?.examaverage?.examscore_set?.map(
                  (item) => item.exam.ExamName
                )}
              />
            </SectionCard>
            <SectionCard title="روند نمرات تکالیف" icon={BarChartOutlined}>
              <ShareChart
                data={profileData?.assignmentaverage?.assignmentscore_set?.map(
                  (item) => item.score
                )}
              />
            </SectionCard>
          </div>
        </>
      ) : (
        <>
          <PageHeader
            title="پروفایل دانش‌آموز"
            description="این حساب غیرفعال است"
            icon={PersonOutline}
          />
          <SectionCard title="حساب غیرفعال" icon={BlockOutlined}>
            <EmptyState
              icon={BlockOutlined}
              title={`کاربر ${Id} فعال نیست`}
              description={[profileData.first_name, profileData.last_name]
                .filter(Boolean)
                .join(" ")}
            />
            <div className="flex justify-center">
              <button
                type="button"
                onClick={() => toggleUser.reFetch()}
                className="rounded-soft bg-primary px-2xl py-sm text-base text-white transition-colors duration-150 hover:bg-primary-hover active:bg-primary-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary motion-reduce:transition-none"
              >
                فعال‌سازی حساب
              </button>
            </div>
          </SectionCard>
        </>
      )}

      <Modal
        open={directMoney}
        onClose={handleClose}
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <DirectMoney close={handleClose} get={fetchData} Id={Id} edit={edit} />
      </Modal>
      <Modal
        open={signedCheck}
        onClose={handleClose}
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <SigendCheck
          close={handleClose}
          get={fetchData}
          Id={Id}
          edit={editCheck}
        />
      </Modal>
      <Modal
        open={passwordModal}
        onClose={handleClose}
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Password close={handleClose} Id={profileData?.username} />
      </Modal>
    </div>
  );
};

export default Profile;
